import { render, staticRenderFns } from "./imgUploadDc.vue?vue&type=template&id=1944b45b"
import script from "./imgUploadDc.vue?vue&type=script&lang=js"
export * from "./imgUploadDc.vue?vue&type=script&lang=js"
import style0 from "./imgUploadDc.vue?vue&type=style&index=0&id=1944b45b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports